import {useCallback, useEffect, useState} from "react";
import {useLocation} from "react-router-dom";
import MobileSidebar from "./MobileSidebar";
import {MOBILE_SIDEBAR_OPEN_EVENT} from "./mobileSidebarEvents";

const MobileSidebarHost = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const isSportsRoute = location.pathname.startsWith("/sports");

  useEffect(() => {
    const handleOpen = () => setIsOpen(true);
    window.addEventListener(MOBILE_SIDEBAR_OPEN_EVENT, handleOpen);
    return () => window.removeEventListener(MOBILE_SIDEBAR_OPEN_EVENT, handleOpen);
  }, []);

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <MobileSidebar
      isOpen={isOpen}
      onClose={handleClose}
      elevated={isSportsRoute}
    />
  );
};

export default MobileSidebarHost;
